<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import Box from './_wrappers/Box.svelte';
    import DisplayComponent from '$lib/components/DisplayComponent/DisplayComponent.svelte';
    import clsx from 'clsx';

    // Types
    import type { Box as BoxType, FlexAlign } from '$lib/types/Components/SharedTypes';
    import type { TransitionEffect, Theme } from '$lib/types/Theme';
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Field } from '$lib/types/Field';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';
    import type { ResultMapping } from '$lib/types/ResultMapping';
    import type { Language } from '$lib/types/Language';

    export let box: BoxType;
    export let verticalAlign: FlexAlign;
    export let framed = false;
    export let childComponents: Component[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'default';
    export let resultMapping: ResultMapping;
    export let theme: Theme;
    export let nextPage = '';
    export let currentPage = '';
    export let campaignId = '';
    export let companyId = '';
    export let cookiesEnabled = false;
    export let fields: Field[] = [];
    export let firstResultPage = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let language: Language = 'de';
    export let layout = DEFAULT_LAYOUT;

    const columnBox: BoxType = {
        top: 'none',
        right: 'none',
        bottom: 'none',
        left: 'none',
        backgroundColor: framed ? box.backgroundColor : 'transparent',
    };
</script>

<Box {...columnBox} {transitionDelay} {transitionEffect} rounded fullHeight>
    <div
        class={clsx('flex h-full flex-col', {
            'p-4 sm:p-6 xl:p-8': framed,
            'justify-start': verticalAlign === 'start',
            'justify-center': verticalAlign === 'center',
            'justify-end': verticalAlign === 'end',
        })}
    >
        {#each childComponents as component, index}
            <DisplayComponent
                id={component._id}
                {language}
                {campaignId}
                {companyId}
                {cookiesEnabled}
                componentType={component.componentType}
                childComponents={component.components}
                content={component.content}
                {theme}
                {nextPage}
                {currentPage}
                {resultMapping}
                {fields}
                {firstResultPage}
                {trackingProperties}
                {index}
                layout={{ ...layout, isInColumn: true, isInFramedColumn: framed }}
            />
        {/each}
    </div>
</Box>
